import { get } from 'lodash';
import { MyInfo } from './MyInfo.model';
import { StructureStatusEnum } from './../enum/structure-status.enum';
import { RoleNameType } from '../enum/role-name.enum';
import { IDTypeEnum } from '../enum/id-type.enum';


export class Owner {
  structure_status          : StructureStatusEnum | undefined;
  myinfo                    : MyInfo;
  live_status               : string;
  dod                       : string;
  role_name                 : RoleNameType;
  own_property              : boolean | undefined;
  children_care_and_control : string | null;
  spr_obtained_date         : string;
  relationship_with_owner   : string;
  is_related                : boolean | undefined; 
  structure_order           : string;
  current_structure_order   : string;
  gross_monthly_income      : string | undefined;
  spouse_id_type            : IDTypeEnum | undefined;
  spouse                    : string;

  constructor(initial?: any) {
    this.structure_status          = get(initial, 'structure_status',          undefined);
    this.myinfo                    = get(initial, 'myinfo',                    new MyInfo(initial)); //Required initial for retrieve saveDraft mapping  used
    this.own_property              = get(initial, 'own_property',              undefined);
    this.children_care_and_control = get(initial, 'children_care_and_control', null);
    this.relationship_with_owner   = get(initial, 'relationship_with_owner',   '');
    this.is_related                = get(initial, 'is_related',                undefined);
    this.structure_order           = get(initial, 'structure_order',                '');
    this.current_structure_order          = get(initial, 'current_structure_order',                '');
    this.spr_obtained_date         = get(initial, 'spr_obtained_date',  '');
    this.gross_monthly_income      = get(initial, 'gross_monthly_income',  undefined);
    this.live_status               = get(initial, 'live_status',  "A") || "A"; //PREVENT FALSY VALUE
    this.dod                       = get(initial, 'dod',  "");
    this.role_name                 = get(initial, 'role_name',  "");
    this.spouse_id_type            = get(initial, 'spouse_id_type',  undefined);
    this.spouse                    = get(initial, 'spouse',  "");
  }
}
